import axios from 'axios'
import moment from 'moment'
import config from '../variables/config'

export const REQUEST_SENT = 'dates/REQUEST_SENT'
export const MESSAGE_SHOWN = 'dates/MESSAGE_SHOWN'
export const REQUEST_FAILED = 'dates/REQUEST_FAILED'
export const REQUEST_FINISHED = 'dates/REQUEST_FINISHED'

const initialState = {
  data: [],
  requestFailed: false,
  requestLoading: false,
  requestFinished: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        data: action.dates,
        requestFinished: true,
        requestLoading: false
      }

    case MESSAGE_SHOWN:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    default:
      return state
  }
}

export const fetchDates = () => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      dispatch({ type: REQUEST_SENT })

      var dates = (await axios.get(
        config.serverURL +
          '/BookingDates' +
          config.endpoint +
          '?access_token=' +
          token
      )).data
      if (Array.isArray(dates)) {
        dates.sort((a, b) => {
          var dateOne = moment(a.startDate)
            .startOf('day')
            .format()
          var dateTwo = moment(b.startDate)
            .startOf('day')
            .format()

          return moment.utc(dateOne).diff(dateTwo)
        })

        dispatch({ type: REQUEST_FINISHED, dates: dates })
      } else {
        dispatch({ type: REQUEST_FAILED })
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const createDates = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      const daysMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      var newDates = {
        endDate: data.endDate.format(),
        startDate: data.startDate.format()
      }
      data.days.forEach((day, i) => {
        var key = daysMap.indexOf(day.name) + ''
        newDates[key] = {}
        newDates[key].peak = day.peak
        newDates[key].timeSlots = data.timeSlots[i]
          .filter(slot => slot.selected)
          .map(slot => slot.name)
      })
      //Party BookingDates
      await axios.post(
        config.serverURL +
          '/BookingDates' +
          config.endpoint +
          '?access_token=' +
          token,
        newDates
      )

      dispatch(fetchDates(true))
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const finishedRequest = () => {
  return dispatch => {
    dispatch({ type: MESSAGE_SHOWN })
  }
}
